<template>
  <div class="m-tabs-content">
    <el-row>
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <span>订单基础信息</span>
        </div>
        <div>
          <el-row>
            <el-col :span="2" class="m-label">派单时间</el-col>
            <el-col :span="5">
              <el-input v-model="editOrder.assign_at" :size="inputSize" disabled></el-input>
            </el-col>
            <el-col :span="2" :offset="1" class="m-label">订单来源</el-col>
            <el-col :span="5">
              <el-cascader ref="cascaderOrderFromInput" v-model="editOrder.platform" placeholder="请选择"
                :options="fromOptions" :size="inputSize" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @visible-change="handleVisibleChange($event, 'plat_form')" :filter-method="filterOptions">
              </el-cascader>
            </el-col>
            <el-col :span="2" :offset="1" class="m-label">订单编号</el-col>
            <el-col :span="5">
              <el-input v-model="editOrder.order_num" :size="inputSize" disabled></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="m-label">订单分类</el-col>
            <el-col :span="21">
              <el-radio-group v-model="editOrder.order_cate" @input="getOrderRegType(editOrder.order_cate)"
                :size="inputSize">
                <el-radio-button :label="1">注册</el-radio-button>
                <el-radio-button :label="2">套餐</el-radio-button>
                <el-radio-button :label="3">单品</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row v-if="editOrder.order_cate != '3'">
            <el-col :span="2" class="m-label">订单类型</el-col>
            <el-col :span="22">
              <el-select ref="orderRegSelect" v-model="editOrder.order_reg_type" placeholder="请选择" :size="inputSize"
                clearable style="width: 100%">
                <el-option v-for="reg in saveOrderRegs" :key="reg.order_reg_id" :label="reg.order_reg_name"
                  :value="reg.order_reg_id"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row v-if="editOrder.order_cate == '3'">
            <el-col :span="2" class="m-label">单品</el-col>
            <el-col :span="22">
              <el-select v-model="editOrder.mealSingles" multiple filterable placeholder="请选择" clearable
                :size="inputSize" style="width: 100%" :key="modalKey">
                <el-option v-for="meal in mealSingles" :key="meal.item_id" :label="meal.item_name"
                  :value="meal.item_id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row v-if="editOrder.order_cate != '1' &&
              ![3, 14, 15].includes(editOrder.order_reg_type)
              ">
            <el-col :span="2" class="m-label">续费订单</el-col>
            <el-col :span="21" style="margin-top: 0.1rem">
              <el-switch @change="handleSwitcher" v-model="editOrder.is_renew" active-color="#5789F4"
                inactive-color="#dcdfe6" active-value="是" inactive-value="否">
              </el-switch>
            </el-col>
          </el-row>
          <el-row v-show="editOrder.order_cate !== null && editOrder.order_cate !== 1">
            <el-col :span="2" class="m-label">服务公司</el-col>
            <el-col :span="21">
              <el-select v-model="editOrder.company_id" filterable remote reserve-keyword placeholder="输入公司"
                :size="inputSize" clearable :remote-method="remoteMethod" @change="handleChangeCompany"
                :loading="loading" style="width: 100%">
                <el-option v-for="company in companies" :key="company.id" :label="company.company_name"
                  :value="company.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row v-if="editOrder.is_renew === '是' &&
              editOrder.company_id != '' &&
              flow_tax.length != 0
              ">
            <el-col :span="2" class="m-label">流水编号</el-col>
            <el-col :span="21">
              <el-input v-model="editOrder.acc_discharge_no" :size="inputSize" clearable></el-input>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-row>
    <el-row>
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <span>服务商信息</span>
        </div>
        <div>
          <el-row>
            <el-col :span="2" class="m-label">服务商</el-col>
            <el-col :span="9">
              <el-select v-model="editOrder.service_business" filterable placeholder="请选择" clearable :size="inputSize"
                @click.native="getServiceProvider">
                <el-option v-for="option in serviceProvider" :key="option.id" :label="option.business_name"
                  :value="option.business_name">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-row>

    <el-row v-if="showEditMealSingles || isEditOrderRegTypeInclueded">
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <span>财务信息</span>
        </div>
        <div>
          <el-row>
            <el-col :span="2" class="tr m-label text_right">零申报</el-col>
            <el-col :span="20" :offset="1">
              <el-radio-group size="mini" :disabled="true">
                <el-radio :label="1" border>是</el-radio>
                <el-radio :label="2" border>否</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="tr m-label text_right">开始时间</el-col>
            <el-col :span="20" :offset="1">
              <el-date-picker :disabled="true" type="month" size="mini" value-format="yyyy-MM" style="width: 100%">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="tr m-label text_right">服务时间</el-col>
            <el-col :span="20" :offset="1">
              <el-date-picker v-model="editOrder.server_time" type="monthrange" size="mini" value-format="yyyy-MM"
                range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" style="width: 70%">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="tr m-label text_right">是否赠送</el-col>
            <el-col :span="20" :offset="1">
              <el-radio-group v-model="editOrder.include_gifts" size="mini" @input="handleControl">
                <el-radio :label="1" border>是</el-radio>
                <el-radio :label="0" border>否</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row v-if="editOrder.include_gifts === 1">
            <el-col :span="2" class="tr m-label text_right">赠送时长</el-col>
            <el-col :span="20" :offset="1">
              <el-input v-model.trim="editOrder.gifts_length" maxlength="3" placeholder="请输入赠送时长（月）" size="mini"
                clearable></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="tr m-label text_right">收费标准</el-col>
            <el-col :span="20" :offset="1">
              <el-input :disabled="true" size="mini" clearable></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="tr m-label text_right">增值服务</el-col>
            <el-col :span="20" :offset="1">
              <el-table :data="addServer.take_money_rule_real" style="width: 100%" border>
                <el-table-column label="服务名称" width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.row.value_add.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="服务频次" width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.row.value_add.type }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="参考价格" width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.row.value_add.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="实际价格" width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-row>

    <el-row>
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <span>客户信息</span>
        </div>
        <div>
          <el-row>
            <el-col :span="2" class="m-label">客户来源</el-col>
            <el-col :span="9">
              <el-cascader ref="cascaderCustomerSourceInput" v-model="editOrder.sources" placeholder="请选择"
                :options="sources" :size="inputSize" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @visible-change="handleVisibleChange($event, 'customer_source')"
                :filter-method="filterOptions">
              </el-cascader>
            </el-col>
            <el-col :span="2" :offset="1" class="m-label">客户姓名</el-col>
            <el-col :span="9">
              <el-input v-model="editOrder.customer_name" :size="inputSize" clearable></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="m-label">客户隶属</el-col>
            <el-col :span="9">
              <el-radio-group v-model="editOrder.customer_belongs" size="mini">
                <el-radio-button v-for="item in customerBelongs" :label="item.id" :key="item.id">
                  {{ item.name }}
                </el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-row>
    <el-row>
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <span>人员信息</span>
        </div>
        <div>
          <el-row>
            <el-col :span="2" class="m-label">转化人员</el-col>
            <el-col :span="5">
              <el-cascader v-model="editOrder.convert" placeholder="请选择" :options="personnelConvert" size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false }" filterable @click.native="getAdminUser"
                :filter-method="filterOptions">
              </el-cascader>
            </el-col>
            <el-col :span="2" :offset="1" class="m-label">服务人员</el-col>
            <el-col :span="5">
              <el-cascader v-model="editOrder.operator" placeholder="请选择" :options="personnel" size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false }" filterable @click.native="getAdminUser"
                :filter-method="filterOptions">
              </el-cascader>
            </el-col>
            <el-col :span="2" :offset="1" class="m-label">沟通人员</el-col>
            <el-col :span="5">
              <el-cascader v-model="editOrder.consultant" placeholder="请选择" :options="personnel" size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false }" filterable @click.native="getAdminUser"
                :filter-method="filterOptions">
              </el-cascader>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-row>
    <el-row>
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <span>收款信息</span>
        </div>
        <div>
          <el-row>
            <el-col :span="2" class="m-label">订单金额</el-col>
            <el-col :span="9">
              <el-input v-model="editOrder.total_amount" :size="inputSize" clearable></el-input>
            </el-col>
            <div v-if="editOrder.moneyin != 18">
                  <el-col :span="2" :offset="1" class="m-label">支付时间</el-col>
                  <el-col :span="9">
                    <datetime-com :disabled="true" :showValue="editOrder.pay_moment"/>
                  </el-col>
                </div>
          </el-row>
          <el-row>
            <el-col :span="2" class="m-label">收款方式</el-col>
            <el-col :span="9">
              <el-cascader style="width: 100%" v-model="editOrder.moneyin" placeholder="请选择"
                :options="moneyInCateOptions" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                filterable @click.native="loadMoneyInCate" :filter-method="filterOptions">
              </el-cascader>
            </el-col>
          </el-row>
          <el-row v-if="editOrder.moneyin != 18">
            <el-col :span="2" class="m-label" style="margin-top: 0.4rem">收款凭证</el-col>
            <el-col :span="21">
              <el-upload action="https://weixin.qiyehuo.com/api/admin/tyc_order/upfile"
                accept="image/png, image/jpeg, image/gif" :headers="headers" multiple ref="editUploadMutiple"
                :file-list="editOrder.editFileLists" :limit="editlimit" :before-upload="beforeAvatarUpload"
                :on-success="editHandleAvatarSuccess" :on-change="editHandleAvatarChange"
                :on-preview="editHandlePictureCardPreview" :on-remove="editHandleRemoveR">
              </el-upload>
              <div id="editPreview" @paste="editHandlePaste"
                style="border: 2px dashed #409eff; border-radius: 5px; padding: 10px">
                <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
              </div>
              <el-dialog :visible.sync="editDialogVisible" :modal="false">
                <img height="50%" width="50%" :src="editDialogImageUrl" alt="" />
              </el-dialog>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-row>

    <el-row class="bottom-btn">
      <el-button @click="handleSave" size="mini" type="primary">保存</el-button>
    </el-row>
  </div>
</template>

<script>
import { filterKeywordOptions } from '../../../lib/cascaderUtils.js';
import DatetimeCom from '../../../commonReform/DatetimeCom';
export default {
  name: "EditOrder",
  components: { DatetimeCom },
  props: {
    orderid: Number,
  },
  data() {
    return {
      inputSize: "small",
      loading: false,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      fromOptions: [],
      mealSingles: [],
      companies: [],
      serviceProvider: [],
      addServer: {
        take_money_rule_real: [],
      },
      sources: [],
      customerBelongs: [],
      personnel: [],
      moneyInCateOptions: [],
      editNeedUrl: [],
      flow_tax: [],
      saveOrderRegs: [],
      editDialogVisible: false,
      editDialogImageUrl: "",
      editlimit: 10,
      modalKey: 0,
      editOrder: {
        id: "",
        editFileLists: [],
        mealSingles: [],
        order_reg_type: "",
        order_cate: "",
        company_id: "",
        customer_belongs: "1",
        platform: "", // 订单来源
        sources: null, // 客户来源
        is_renew: "否",
        acc_discharge_no: "",
        service_business: "企业火",
        server_time: [],
        include_gifts: false,
        gifts_length: "",
        customer_name: "",
        consultant: "",
        convert: "",
        operator: "",
        total_amount: 0,
        moneyin: "",
        pay_moment: ''
      },
      additionalData: { value: "自助下单", label: "自助下单" },
      cateFlag: ''
    };
  },
  computed: {
    showEditMealSingles() {
      return this.containsAny(this.editOrder.mealSingles, [1, 11, 41, 43, 52, 53]);
    },
    isEditOrderRegTypeInclueded() {
      const validOrderRegTypes = [11, 12, 13, 9, 10, 7, 6, 2];
      return validOrderRegTypes.includes(this.editOrder.order_reg_type);
    },
    personnelConvert() {
      return [this.additionalData, ...this.personnel];
    },
  },
  created() {
    this.getMeals();
    this.getSources();
    this.getCustomerBelongs();
    this.getAdminUser();
    this.loadMoneyInCate();
    this.getFrom();
  },
  watch: {
    orderid(newVal) {
      if (newVal === 0) return;
      this.companies = [];
      this.editOrder.editFileLists = [];
      this.editOrder.id = newVal;
      this.getOrderEditDetail(newVal);
    },
  },
  methods: {
    getOrderEditDetail(orderId) {
      this.$axios
        .get("api/admin/tyc_order/get_order_by_id?id=" + orderId)
        .then(({ data }) => {
          if (data.code === 0) {
            let res = data.data.data;
            let orderFroms = data.data.orderFrom;

            this.editOrder.assign_at = res.assign_at;
            this.editOrder.platform = this.getPlatFromId(orderFroms, res.platform);
            this.editOrder.order_num = res.order_num;
            this.editOrder.is_renew = res.is_renew;
            this.editOrder.company_id = res.company_id;
            this.editOrder.acc_discharge_no = res.acc_discharge_no;
            this.editOrder.service_business = res.service_business;
            this.editOrder.sources = res.sources;
            this.editOrder.customer_name = res.customer_name;
            this.editOrder.customer_belongs = res.customer_belongs;
            this.editOrder.total_amount = res.total_amount;
            this.editOrder.moneyin = res.moneyin;
            this.editOrder.pay_moment = res.pay_moment

            if (res.order_reg.order_cate === "注册订单") {
              this.cateFlag = "1"
              this.editOrder.order_cate = "1";
              this.editOrder.order_reg_type = res.order_reg_type;
              this.editOrder.mealSingles = [];
              this.getOrderRegType(this.editOrder.order_cate);
            } else if (res.order_reg.order_cate === "套餐订单") {
              this.cateFlag = "2"
              this.editOrder.order_cate = "2";
              this.editOrder.order_reg_type = res.order_reg_type;
              this.editOrder.mealSingles = [];
              this.getOrderRegType(this.editOrder.order_cate);
            } else if (res.order_reg.order_cate === "单品订单") {
              this.cateFlag = "3"
              this.editOrder.order_cate = "3";
              this.editOrder.order_reg_type = "";
              this.modalKey++;
              this.editOrder.mealSingles = this.getSingleIds(res.meal_singles);
            }

            if (res.company_id && res.company) {
              this.companies.push({ id: res.company_id, company_name: res.company });
            }
            if (res.advisor) {
              this.editOrder.consultant = res.advisor.id;
            }
            if (res.trans) {
              this.editOrder.convert = res.trans.id;
            } else {
              this.editOrder.convert = "自助下单";
            }
            if (res.operator) {
              this.editOrder.operator = res.operator.id;
            }
            if (res.receipt_pic) {
              for (let i = 0; i < res.receipt_pic.length; i++) {
                this.editOrder.editFileLists.push({
                  url: res.receipt_pic[i].receive_url,
                  name: res.receipt_pic[i].name,
                });
              }
            }
            if (res.company_obj && res.company_obj.fin_table) {
              const start_time = res.company_obj.fin_table.start_time;
              const end_time = res.company_obj.fin_table.end_time;
              this.editOrder.server_time = [start_time, end_time];
              this.editOrder.include_gifts = res.company_obj.fin_table.include_gifts;
              this.editOrder.gifts_length = res.company_obj.fin_table.gifts_length;
            }
            // return;
          }
        })
        .catch();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    getPlatFromId(arrlists, value) {
      return arrlists.find(item => item.name === value).id;
    },
    handleVisibleChange(visible, field) {
      const refMap = {
        'plat_form': {
          inputRef: 'cascaderOrderFromInput',
          callback: this.getFrom
        },
        'customer_source': {
          inputRef: 'cascaderCustomerSourceInput',
          callback: this.getSources
        },
      };
      const { inputRef, callback } = refMap[field];
      if (visible) {
        const cascaderInput = this.$refs[inputRef];
        if (cascaderInput && cascaderInput.$refs.input) {
          cascaderInput.$refs.input.focus();
        }
        this.$nextTick(callback);
      }
    },
    handleControl() {
      this.editOrder.gifts_length = '';
    },
    handleSave() {
      if (this.editOrder.order_cate == "1" || this.editOrder.order_cate == "2") {
        if (!this.editOrder.order_reg_type) {
          this.$message.error("请选择订单类型！");
          return;
        }
      }
      if (this.editOrder.order_cate == "3" && this.editOrder.mealSingles.length <= 0) {
        this.$message.error("请选择单品信息！");
        return;
      }
      if (this.editOrder.is_renew === "是" && this.editOrder.order_reg_type === 3) {
        this.$message.error("续费订单时，订单类型不能为云上公司注册！");
        return;
      }
      if (!/^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(this.editOrder.total_amount)) {
        this.$message.error("订单金额类型错误！");
        return;
      }
      if (!this.editOrder.moneyin) {
        this.$message.error("请选择收款方式！");
        return;
      }
      if (this.editOrder.convert !== '自助下单' && this.editOrder.moneyin != 18 && this.editOrder.editFileLists.length <= 0) {
        this.$message.warning("请上传收款凭证!");
        return;
      }
      
      this.$axios.post("api/admin/tyc_order/save", this.editOrder).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.$emit("data-updated");
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getOrderRegType(cate_id) {
      if (this.cateFlag !== this.editOrder.order_cate) {
        this.editOrder.order_reg_type = "";
        this.editOrder.mealSingles = [];
        this.editOrder.is_renew = "否";
        this.editOrder.company_id = "";
        this.editOrder.acc_discharge_no = "";
        this.editOrder.server_time = [];
        this.editOrder.include_gifts = false;
        this.editOrder.gifts_length = "";
        this.modalKey++;
        // console.log(this.editOrder.order_reg_type);
      }
      this.$axios
        .post("/api/admin/tyc_order/get_order_reg_type_by_cate", {
          order_cate: cate_id,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.saveOrderRegs = data.data.orderRegs;
            // this.$forceUpdate();
          }
        });
    },
    handleSwitcher() {
      this.editOrder.company_id = "";
    },
    getSingleIds(arr) {
      let ids = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].item_id) {
          ids.push(arr[i].item_id);
        } else {
          ids.push(arr[i]);
        }
      }
      return ids;
    },
    getCompanines() {
      this.$axios
        .get("api/admin/company/companines")
        .then(({ data }) => {
          if (data.code === 1) {
            this.companies = data.data;
          }
        })
        .catch();
    },
    remoteMethod(query) {
      if (query !== "") {
        setTimeout(() => {
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleChangeCompany(value) {
      if (typeof value === "string" && value.trim().length === 0) {
        this.clearAddLoadingData();
        return;
      }
      this.$axios
        .post("/api/admin/tyc_orders/get_com_tax_record", { value: value })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.flow_tax = data.data.flow_tax_records;

            if (data.data.company.fin_reg) {
              // 服务时间
              const stime =
                data.data.company.fin_reg.start_time != null
                  ? data.data.company.fin_reg.start_time
                  : "";
              const etime =
                data.data.company.fin_reg.end_time != null
                  ? data.data.company.fin_reg.end_time
                  : "";
              this.editOrder.server_time = [stime, etime];
              this.editOrder.include_gifts = data.data.company.fin_reg.include_gifts;
              this.editOrder.gifts_length = data.data.company.fin_reg.gifts_length;
            }

            if (data.data.company) {
              this.addServer.take_money_rule_real = data.data.company.real_price;
            }
            this.editOrder.flow_tax = "";
          } else {
            this.editOrder.flow_tax = "";
          }
        });
    },
    clearAddLoadingData() {
      this.addServer.take_money_rule_real = [];
    },
    beforeAvatarUpload(file) {
      const isLt100M = file.size / (1024 * 100) < 100;
      if (!isLt100M) {
        this.$message.error("上传总大小不能超过 100MB!");
        return false;
      }
    },
    editHandleAvatarChange(res, file) {
      this.editOrder.editFileLists = file;
    },
    editHandlePictureCardPreview(file) {
      this.editDialogVisible = true;
      this.editDialogImageUrl = file.url;
    },
    editHandleRemoveR(file, fileList) {
      this.editNeedUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.editNeedUrl.splice(index, 1);
        }
      });
      this.$axios
        .post("/api/admin/tyc_order/remove_receipt", { img_name: file.name })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.editNeedUrl = [];
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    editHandleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.editNeedUrl.push({ url: res.url, name: file.name, uid: file.uid });
      }
      this.$axios
        .post("/api/admin/edit_receive_path", {
          id: this.editOrder.id,
          path: this.editNeedUrl,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.editNeedUrl = [];
          } else {
            this.$message.error(data.msg);
          }
        });
    },

    editHandlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地！");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        file = items[i].getAsFile();
      }
      if (this.editOrder.editFileLists.length >= this.editlimit) {
        this.$message.error(`上传文件数量不能超过 ${this.editlimit} 个!`); // 图片数量超出
        return;
      }
      this.$refs.editUploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
      this.$refs.editUploadMutiple.submit(); // 提交图片上传队列
    },
    getServiceProvider() {
      this.$axios
        .get("api/admin/service_provider/get_service_provider")
        .then(({ data }) => {
          if (data.code === 0) {
            this.serviceProvider = data.data.serviceProvider;
          }
        })
        .catch();
    },
    getCustomerBelongs() {
      this.$axios
        .get("api/admin/get_customer_belongs")
        .then(({ data }) => {
          if (data.code === 0) {
            this.customerBelongs = data.data.data.data;
          }
        })
        .catch();
    },
    getMeals() {
      this.$axios
        .get("api/admin/tyc_order/meal")
        .then(({ data }) => {
          if (data.code === 1) {
            this.mealSingles = data.data;
          }
        })
        .catch();
    },
    getAdminUser() {
      this.$axios
        .get("api/admin/user/branch")
        .then(({ data }) => {
          if (data.code === 1) {
            this.personnel = data.data;
          }
        })
        .catch();
    },
    getSources() {
      this.$axios
        .get("api/custom_source/get_source_tree")
        .then(({ data }) => {
          if (data.code === 1) {
            this.sources = data.data;
          }
        })
        .catch();
    },
    loadMoneyInCate() {
      this.$axios
        .get("api/admin/moneyin/get_tree_data")
        .then(({ data }) => {
          if (data.code === 1) {
            this.moneyInCateOptions = data.data;
          }
        })
        .catch();
    },
    getFrom() {
      this.$axios
        .get("api/admin/other_orders/get_from_tree")
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data;
          }
        })
        .catch();
    },
    containsAny(array, values) {
      return array.some((item) => values.includes(item));
    },
  },
  mounted() { },
};
</script>

<style scoped>
.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.tabs-title {
  color: #409eff;
}

.el-row {
  margin-bottom: 0.4rem;
}

/* .m-label {
  line-height: 0.64rem;
} */
.el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
}

.bottom-btn {
  padding: 0.2rem;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/tyc_order/components/EditOrder.vue